import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SelectedElementOuter from './selected-element-outer';
import OperationRenderServiceManager from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/operation-render-service-manager';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ServicesContext } from '../context';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@observer
class SelectedElementsLayer extends Component<{ scale: number; }> {
    public static contextType = ServicesContext;

    private selectedElementsInGroup: IElementBaseModel[];
    // private selectedElementsInSmartArt: IElementBaseModel[];
    private sortedElementsOnSlide: IElementBaseModel[];
    private selectedElementsOnSlide: IElementBaseModel[];
    public render() {
        if (!this.getSelectionService()?.currentSlide) {
            return null;
        }
        const isOperation = this.getIsOperation();

        // 操作态（拖拽、扩缩、旋转）不会触发选择元素的变化，所以不需要重新排序
        if (!isOperation) {
            this.getSortElement();
        }

        // 新交互，是否选中了组合子元素
        const selectedElementInGroupInMobile = browser.isMobile && this.selectedElementsInGroup?.length > 0;
        return (
            <React.Fragment
            >
                {
                    // 底层放上元素的编辑能力
                    this.sortedElementsOnSlide?.map(elementOnSlide => (
                        <SelectedElementOuter
                            element={elementOnSlide}
                            key={`edit-selected-${elementOnSlide.key}`}
                            scale={this.props.scale}
                            selectedElementInGroupInMobile={selectedElementInGroupInMobile}
                        >
                        </SelectedElementOuter>))
                }
                {
                    this.selectedElementsInGroup?.map(elementInGroup => (
                        <SelectedElementOuter
                            element={elementInGroup}
                            key={`edit-selected-${elementInGroup.key}`}
                            scale={this.props.scale}
                        >
                        </SelectedElementOuter>))
                }
                {/* 暂时不暴露smartArt的子元素选中框
                {
                    this.selectedElementsInSmartArt?.map(elementInSmartArt => (
                        <SelectedElementOuter
                            element={elementInSmartArt}
                            key={`edit-selected-${elementInSmartArt.key}`}
                            scale={this.props.scale}
                        >
                        </SelectedElementOuter>))
                }
                */}
            </React.Fragment>
        );
    }

    private getSortElement() {
        this.selectedElementsOnSlide = this.getSelectionService()
            ?.selectedElements.selectedArrayForType(SelectedEleMgrType.SLIDE);
        this.sortedElementsOnSlide = this.getSelectionService().selectedSlides
            .sortSelectedArray(this.getSelectionService()?.currentSlide, this.selectedElementsOnSlide);
        this.selectedElementsInGroup = this.getSelectionService()
            ?.selectedElements.selectedArrayForType(SelectedEleMgrType.GROUP);
        // this.selectedElementsInSmartArt = this.getSelectionService()
        //     ?.selectedElements.selectedArrayForType(SelectedEleMgrType.SMART_ART);
        this.setRegionRefreshElement();
    }

    /**
     * 缓存局部刷新元素的索引
     */
    private setRegionRefreshElement() {
        const currentSlide = this.getSelectionService()?.currentSlide;
        const sortElementLength = this.sortedElementsOnSlide.length;
        const childrenLength = currentSlide?.children.length;
        if (childrenLength && sortElementLength) {
            const { children } = currentSlide;
            const [startModel] = this.sortedElementsOnSlide;
            const endModel = this.sortedElementsOnSlide[sortElementLength - 1];
            const startIndex = children.findIndex(item => item === startModel);
            let endIndex = children.findIndex(item => item === endModel);
            endIndex = endIndex === -1 ? startIndex : endIndex;
            OperationRenderServiceManager.getInstance().canvasOperationInfo.startIndex = startIndex;
            OperationRenderServiceManager.getInstance().canvasOperationInfo.endIndex = endIndex;
        } else {
            OperationRenderServiceManager.getInstance().canvasOperationInfo.startIndex = 0;
            OperationRenderServiceManager.getInstance().canvasOperationInfo.endIndex = 0;
        }
    }

    private getIsOperation() {
        return this.context.editingStateManager.isDragging
            || this.context.editingStateManager.isResizing
            || this.context.editingStateManager.isRotating;
    }

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer?.selectionService;
    }
}

export default SelectedElementsLayer;
